import React from 'react'
import PropTypes from 'prop-types'

const Author = (props) => {
  const { name, bio, avatar, createdAt } = props
  const { file: { url, fileName } } = avatar
  return (
    <div className='firo-author-content row'>
      <div className='col-lg-2'>
        <img width='90' height='90' className='box-shadow' src={url} alt={fileName} />
      </div>
      <div className='col-lg-10 content'>
        <h5><span>{name}</span></h5>
        <time>{createdAt}</time>
        <p dangerouslySetInnerHTML={{ __html: bio.childMarkdownRemark.html }} />
      </div>
    </div>
  )
}

Author.propTypes = {
  name: PropTypes.string,
  bio: PropTypes.shape(),
  avatar: PropTypes.shape(),
  createdAt: PropTypes.string
}

Author.defaultProps = {
  name: '',
  bio: {},
  createdAt: '',
  avatar: {
    file: {
      url: '',
      fileName: ''
    }
  }
}

export default Author
